// extracted by mini-css-extract-plugin
export default {"label":"InputFieldWithLabel_label__iMZjt","input":"InputFieldWithLabel_input__bdhz2"};